'use strict';
import { platformHandler } from '../platforms/PlatformHandler'
import { requestPostSail } from '../utils/requester'
import { ID_SLIDE_COMMENT } from '../App/constants';

// Initializes AutoViewer.
export class AutoViewer {

  constructor() {   
    
  }
 
  action( action, data, cb, user ){
  	switch( action ){
      case "checkId": this.checkAutoViewer( data, cb,user )
      break;

      case "join": this.joinAutoViewer( data, user )
      break;

      case "Prev": this.goToBack( data );
      break;

      case "Next": this.goToNext( data );
      break;
    }
  }  

  goToBack = async ( data ) =>{
    var currentIndex = parseInt(data.indexSlide);
    if( currentIndex <= 1 ){
      return;
    }

    this.sendCurrentIndex( currentIndex - 1)
    let state = await this.getObjectState(currentIndex - 1);
    platformHandler.setAutoViewerData( state );
  }

  goToNext = async ( data ) =>{
    var currentIndex = parseInt(data.indexSlide);
    if( currentIndex >= this.dataAutoViewer.slides.length ){
      return;
    }

    this.sendCurrentIndex( currentIndex + 1)
    let state = await this.getObjectState(currentIndex + 1);
    platformHandler.setAutoViewerData( state );
  }

  joinAutoViewer = ( data, user ) =>{
    this.dataAutoViewer = data.resp;
    this.idUser = data.idUser;

    var idActivities = [];
    for( var i = 0; i < this.dataAutoViewer.slides.length; i ++){
      var indexOfId = this.dataAutoViewer.slides[i].note.indexOf(ID_SLIDE_COMMENT);
      var id = "";
      if( indexOfId != -1 ){
        id = platformHandler.getIdActivity( this.dataAutoViewer.slides[i].note, indexOfId );
        idActivities.push( id );
      }
    }

    if( idActivities.length > 0 ){
      this.getInfoActivities( idActivities );
    }
    else{
      this.initViewer();
    }
  }

  getInfoActivities( idActivities ){
    var payload = {
          ids: idActivities,
    };

    requestPostSail( process.env.REACT_APP_URL_SERVICES + 'activity/activitiesAutoViewer', payload, this.callbackActivities );
  }

  callbackActivities = (data) => {
    console.log('data ' , data)
    platformHandler.infoActivities = data.acts;

    this.initViewer();
  }

  getObjectState = async ( index ) =>{
    let initState = {
        communData:{
          idToglea: "",
          url: "",
          slideIndex: index,
          titleToglea: "",
          infoToglea: "",
          previewUrl: this.dataAutoViewer.slides[index-1].url,
      }          
    }

    var indexOfId = this.dataAutoViewer.slides[index-1].note.indexOf(ID_SLIDE_COMMENT);
    if( indexOfId != -1 ){
      var idActivityTemp = platformHandler.getIdActivity(this.dataAutoViewer.slides[index-1].note, indexOfId);
      
      var objectAct = await platformHandler.getObjectInfoActivity(idActivityTemp);
      if( objectAct != null ) {         
        console.log('que pone: ', objectAct)
        initState.communData.titleToglea = objectAct.title;
        initState.communData.infoToglea = objectAct.info;
        initState.communData.url = objectAct.idActivity.url;
        initState.communData.idToglea = idActivityTemp;
      }
    }

    return initState;
  }

  initViewer = async () =>{
    var initState = await this.getObjectState(1);
    platformHandler.setAutoViewerData( initState, this.dataAutoViewer.slides.length );
    this.sendCurrentIndex( 1 );
    platformHandler.sceneManager.openScene("PresentationUser",{autoViewer:true});
  }

  sendCurrentIndex = ( index ) =>{
    console.log('SEND ' + index)

    var payload = {
      idSlide: this.dataAutoViewer.id,
      idUser: this.idUser,
      slideMax: index
    };

    requestPostSail( process.env.REACT_APP_URL_SERVICES + 'AutoviewerRep/setSlideNumber', payload, () => {} );
  }

  checkAutoViewer = ( id, cb, user ) =>{
    var payload = {
      id: id,
      user: user
    };

    this.isExhibitor = false;
    this.callbackJoinFn = cb;
    requestPostSail( process.env.REACT_APP_URL_SERVICES + 'slides/joinAutoviewer', payload, this.callbackAutoViewer );
  }

  callbackAutoViewer = (data) => {
    console.log('callbackAutoViewer', data)
    if( this.callbackJoinFn ){
      this.callbackJoinFn( data );
    }
  }

}

export let autoviewer = new AutoViewer();


// WEBPACK FOOTER //
// ./src/containers/autoViewer/AutoViewer.js